import styled, { css } from 'styled-components';
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";

export default styled.h4`
  margin-top: 0;
  margin-bottom: .75rem;
  font-size: ${themeResponsiveProperty('1.125rem', null)};
  line-height: 1.125rem;

  ${({ related }) => related && css`
    margin-bottom: .5rem;
  `};
`;
